import { useContext, useState } from 'react';
import SelectUnit from '../../../components/SelectUnit/SelectUnit';
import FaceOffDisplay from './FaceOffDisplay/FaceOffDisplay';
import Unit from '../../../types/Unit/Unit';
import { convertToUnit } from '../../../hooks/useFactionData/useFactionData.util';
import { FactionContext } from '../../../Contexts/FactionContext/FactionContext';

function FaceOff() {
  const { faction, updateFaction } = useContext(FactionContext);
  const [selectedUnit, setSelectedUnit] = useState<Unit | undefined>();

  return (
    <div>
      <SelectUnit 
        faction={faction} 
        onUnitSelected={(unit, factionName) => {
          setSelectedUnit(convertToUnit(unit));
          updateFaction(factionName);
        }}
      />
      {selectedUnit && <FaceOffDisplay 
        unit={selectedUnit}
      />}
    </div>
  );
}

export default FaceOff;